export default "__VITE_ASSET__DLgTTk9h__"